import axios from "axios";
import settings from "../settings/settings";

// Axios instance
const request = axios.create({
  baseURL: settings.baseURL,
  timeout: settings.requestTimeout,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    "Accept": "application/json",
    "Accept-Language": "en",
  },
});

/**
 * GLOBAL ERROR HANDLER
 */
export function errorHandler(error) {
  // Backend javob qaytargan bo‘lsa
  if (error.response) {
    if (error.response.status === 401) {
      localStorage.removeItem("token");
      window.location.replace("/login");
    }
    return Promise.reject(error.response);
  }

  // So‘rov yuborilgan, lekin javob yo‘q (CORS / Network)
  if (error.request) {
    console.error("Network / CORS error:", error.request);
    return Promise.reject(error.request);
  }

  // Boshqa xatolar
  return Promise.reject(error);
}

/**
 * REQUEST INTERCEPTOR
 */
request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  errorHandler
);

/**
 * RESPONSE INTERCEPTOR
 */
request.interceptors.response.use(
  (response) => {
    const paginationHeader = response.headers?.["x-pagination"];
    const payload = {
      data: response.data?.result ?? response.data,
    };

    if (paginationHeader) {
      payload.pagination = JSON.parse(paginationHeader);
    }

    return payload;
  },
  errorHandler
);

export default request;
